// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> rebel-residential-prestige -> prestige
// Generated: 2026-09-09T15:23:02.460Z
// Counts: 1 design, 4 content, 2 slot group, 1 collection binding, 3 section, 0 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>See Prestige from the inside out.</strong> Browse the gallery for the details that make each space feel bright, polished, and ready to enjoy—from quartz countertops and stainless steel appliances to clean tile or vinyl flooring, dining areas, and patios that extend your living space outdoors.</p><p>As you move through the photos, picture sunny afternoons by the pool and cabana, a quick match on the courts, or a quiet walk through the landscaped paths around the Prestige setting. The images give you a closer look at the balance of comfort and activity throughout the community without needing to imagine it from a floor plan alone. Explore the finishes, compare the feel of each space, then view more <a class=\"richtext-link\" href=\"/amenities\">community features</a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see Prestige in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury LiVING AT ITS FINEST</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_b5ab777569562e296e7170a1",
      "ec_40af0687f674e21056004382"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
